// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let QueryParams = require("../../../reason/QueryParams.bs.js");
let MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelay__Types = require("./PropertyWizardRelay__Types.bs.js");
let PropertyWizardRelay__Footer = require("./PropertyWizardRelay__Footer.bs.js");
let PropertyWizardRelay__Header = require("./PropertyWizardRelay__Header.bs.js");
let PropertyWizardRelay__Preview = require("./PropertyWizardRelay__Preview.bs.js");
let PropertyWizardRelayNavigation = require("./PropertyWizardRelayNavigation.bs.js");
let PropertyWizardRelay__KeyFacts = require("./PropertyWizardRelay__KeyFacts.bs.js");
let PropertyWizardRelay__Showings = require("./PropertyWizardRelay__Showings.bs.js");
let PropertyWizardRelay__MLSTiming = require("./PropertyWizardRelay__MLSTiming.bs.js");
let PropertyWizardRelay__SaveDraft = require("./PropertyWizardRelay__SaveDraft.bs.js");
let PropertyWizardFormRelay__Effects = require("./PropertyWizardFormRelay__Effects.bs.js");
let PropertyWizardRelay__Description = require("./PropertyWizardRelay__Description.bs.js");
let PropertyWizardRelay__PhotosAndFiles = require("./PropertyWizardRelay__PhotosAndFiles.bs.js");
let PropertyWizardBodyRelayQuery_graphql = require("../../../__generated__/PropertyWizardBodyRelayQuery_graphql.bs.js");
let PropertyWizardRelay__PriceDropCallout = require("./PropertyWizardRelay__PriceDropCallout.bs.js");
let PropertyWizardRelay__RebroadcastWarning = require("./PropertyWizardRelay__RebroadcastWarning.bs.js");
let PropertyWizardRelay__BroadcastQuietSellerWarning = require("./PropertyWizardRelay__BroadcastQuietSellerWarning.bs.js");

function encode(param) {
  return Stdlib_Option.map(param, PropertyWizardRelay__Types.Key.toJs);
}

function decode(string) {
  return Stdlib_Option.flatMap(string, PropertyWizardRelay__Types.Key.fromJs);
}

let StepParam = {
  encode: encode,
  decode: decode
};

function encode$1(param) {
  return Stdlib_Option.map(param, param => param);
}

function decode$1(string) {
  return Stdlib_Option.map(string, string => {
    switch (string) {
      case "dismissed" :
        return "dismissed";
      case "shown" :
        return "shown";
      default:
        return "NotShown";
    }
  });
}

let PriceDropInfo = {
  encode: encode$1,
  decode: decode$1
};

function boolWithDefault($$default) {
  return QueryParams.UseQueryParams.ParamConfigs.fromParamConfig(QueryParams.ParamConfigs.withHiddenDefault(QueryParams.ParamConfigs.booleanParam, $$default));
}

function stepWithDefault($$default) {
  return QueryParams.UseQueryParams.ParamConfigs.fromParamConfig(QueryParams.ParamConfigs.withHiddenDefault(StepParam, $$default));
}

function priceDropWithDefault($$default) {
  return QueryParams.UseQueryParams.ParamConfigs.fromParamConfig(QueryParams.ParamConfigs.withHiddenDefault(PriceDropInfo, $$default));
}

let config = Object.fromEntries([
  [
    "previewing",
    boolWithDefault(false)
  ],
  [
    "step",
    stepWithDefault("keyFacts")
  ],
  [
    "priceDropInfo",
    priceDropWithDefault("NotShown")
  ]
]);

let ParamsConfig = {
  StepParam: StepParam,
  PriceDropInfo: PriceDropInfo,
  boolWithDefault: boolWithDefault,
  stepWithDefault: stepWithDefault,
  priceDropWithDefault: priceDropWithDefault,
  config: config
};

let UseQueryParams = QueryParams.UseQueryParams.Make({
  config: config
});

let use = UseQueryParams.use;

let QueryParams$1 = {
  Key: undefined,
  ParamsConfig: ParamsConfig,
  UseQueryParams: UseQueryParams,
  use: use
};

let convertVariables = PropertyWizardBodyRelayQuery_graphql.Internal.convertVariables;

let convertResponse = PropertyWizardBodyRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = PropertyWizardBodyRelayQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables, PropertyWizardBodyRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, PropertyWizardBodyRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(PropertyWizardBodyRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(PropertyWizardBodyRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(PropertyWizardBodyRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(PropertyWizardBodyRelayQuery_graphql.node, convertVariables);

let LocalDraftPropertyQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function PropertyWizardBodyRelay(props) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let match$1 = use();
  let queryParams = match$1[0];
  let activeStep = queryParams.step;
  let setQueryParams = match$1[1];
  let data = use$1(undefined, "store-only", undefined, undefined);
  let goToStep = step => setQueryParams(undefined, {
    previewing: queryParams.previewing,
    step: step,
    priceDropInfo: queryParams.priceDropInfo
  });
  let match$2 = React.useState(() => {});
  PropertyWizardFormRelay__Effects.use(data.localDraft.fragmentRefs, data.localDraftFormState.fragmentRefs, match$2[1]);
  if (queryParams.previewing) {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(PropertyWizardRelay__Preview.make, {
        draft: data.localDraft.fragmentRefs,
        formState: data.localDraftFormState.fragmentRefs,
        onEditForm: step => setQueryParams(undefined, {
          previewing: false,
          step: step,
          priceDropInfo: queryParams.priceDropInfo
        }),
        currentStep: activeStep
      }),
      className: "flex-1 bg-white"
    });
  }
  let tmp;
  if (typeof mode !== "object") {
    tmp = null;
  } else {
    switch (mode.TAG) {
      case "Edit" :
        tmp = "Click directly on the step you wish to edit below";
        break;
      case "Rebroadcast" :
        let policy = mode._1.broadcastPolicy;
        let exit = 0;
        switch (queryParams.priceDropInfo) {
          case "shown" :
            switch (policy.__typename) {
              case "PropertyBroadcastAllowed" :
                if (policy.priceCondition !== undefined) {
                  tmp = JsxRuntime.jsx(PropertyWizardRelay__PriceDropCallout.make, {
                    onDismiss: () => setQueryParams("replaceIn", {
                      previewing: queryParams.previewing,
                      step: queryParams.step,
                      priceDropInfo: "dismissed"
                    })
                  });
                } else {
                  exit = 1;
                }
                break;
              case "PropertyBroadcastNotAllowed" :
              case "__unselected" :
                exit = 1;
                break;
            }
            break;
          case "dismissed" :
            switch (policy.__typename) {
              case "PropertyBroadcastAllowed" :
                if (policy.priceCondition !== undefined) {
                  tmp = null;
                } else {
                  exit = 1;
                }
                break;
              case "PropertyBroadcastNotAllowed" :
              case "__unselected" :
                exit = 1;
                break;
            }
            break;
          case "NotShown" :
            exit = 1;
            break;
        }
        if (exit === 1) {
          tmp = JsxRuntime.jsx(PropertyWizardRelay__RebroadcastWarning.make, {
            policy: policy,
            draft: data.localDraft.fragmentRefs
          });
        }
        break;
      case "BroadcastQuietSeller" :
        tmp = JsxRuntime.jsx(PropertyWizardRelay__BroadcastQuietSellerWarning.make, {
          privacy: mode._1.privacySetting
        });
        break;
    }
  }
  return JsxRuntime.jsxs(MarkupHelpers.Container.make, {
    className: "flex-1 my-10",
    children: [
      JsxRuntime.jsxs(FormV5.FormSection.make, {
        children: [
          JsxRuntime.jsx(PropertyWizardRelay__Header.make, {
            draft: data.localDraft.fragmentRefs
          }),
          JsxRuntime.jsxs(ViewStack.make, {
            alignItems: "stretch",
            flexDirection: "column",
            children: [
              tmp,
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(PropertyWizardRelay__SaveDraft.SaveDraftIndicator.make, {
                  formState: data.localDraftFormState.fragmentRefs,
                  localDraft: data.localDraft.fragmentRefs
                })
              })
            ]
          })
        ]
      }),
      JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(PropertyWizardRelayNavigation.make, {
          draft: data.localDraft.fragmentRefs,
          formState: data.localDraftFormState.fragmentRefs,
          selectStep: goToStep,
          activeStep: activeStep
        })
      }),
      activeStep === "description" ? JsxRuntime.jsx(PropertyWizardRelay__Description.make, {
          draft: data.localDraft.fragmentRefs,
          formState: data.localDraftFormState.fragmentRefs
        }) : (
          activeStep === "mlsTiming" ? JsxRuntime.jsx(PropertyWizardRelay__MLSTiming.make, {
              draft: data.localDraft.fragmentRefs,
              formState: data.localDraftFormState.fragmentRefs
            }) : (
              activeStep === "photosAndFiles" ? JsxRuntime.jsx(PropertyWizardRelay__PhotosAndFiles.make, {
                  draft: data.localDraft.fragmentRefs
                }) : (
                  activeStep === "keyFacts" ? JsxRuntime.jsx(PropertyWizardRelay__KeyFacts.make, {
                      draft: data.localDraft.fragmentRefs,
                      formState: data.localDraftFormState.fragmentRefs,
                      duplicatedProperty: match$2[0]
                    }) : JsxRuntime.jsx(PropertyWizardRelay__Showings.make, {
                      draft: data.localDraft.fragmentRefs
                    })
                )
            )
        ),
      JsxRuntime.jsx(FormV5.FormSection.make, {
        children: JsxRuntime.jsx(PropertyWizardRelay__Footer.make, {
          step: queryParams.step,
          goToPreview: () => setQueryParams(undefined, {
            previewing: true,
            step: queryParams.step,
            priceDropInfo: queryParams.priceDropInfo
          }),
          goToStep: goToStep,
          draft: data.localDraft.fragmentRefs
        })
      })
    ]
  });
}

let FormSection;

let SaveDraftIndicator;

let KeyFacts;

let Description;

let MLSTiming;

let Showings;

let PhotosAndFiles;

let Validators;

let FormEffects;

let Preview;

let Header;

let Footer;

let make = PropertyWizardBodyRelay;

exports.FormSection = FormSection;
exports.SaveDraftIndicator = SaveDraftIndicator;
exports.QueryParams = QueryParams$1;
exports.LocalDraftPropertyQuery = LocalDraftPropertyQuery;
exports.KeyFacts = KeyFacts;
exports.Description = Description;
exports.MLSTiming = MLSTiming;
exports.Showings = Showings;
exports.PhotosAndFiles = PhotosAndFiles;
exports.Validators = Validators;
exports.FormEffects = FormEffects;
exports.Preview = Preview;
exports.Header = Header;
exports.Footer = Footer;
exports.make = make;
/* config Not a pure module */
